import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import QaqcPipeWpsCreate from './QaqcPipeWpsCreate';
import type { QaqcPipeWps } from '../../../../types';
import { fetchSqlData } from '../../../../services/api';

const QaqcPipeWpsView: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: { record?: QaqcPipeWps } };
  const params = useParams();
  const [record, setRecord] = useState<QaqcPipeWps | undefined>(state?.record);

  useEffect(() => {
    const load = async () => {
      if (record) return;
      const id = params.id ? Number(params.id) : NaN;
      if (!Number.isFinite(id)) return;
      try {
        const res = await fetchSqlData('qaqc_pipe_wps', 'id', id);
        const row = Array.isArray((res as any)?.data) ? (res as any).data[0] : (Array.isArray(res) ? (res as any)[0] : undefined);
        if (row) setRecord(row as QaqcPipeWps);
      } catch {}
    };
    load();
  }, [params.id]);

  const goBack = () => navigate('/qaqc/piping/tools/wps');

  return (
    <QaqcPipeWpsCreate
      mode="edit"
      initialValues={record}
      onBack={goBack}
      viewOnly
    />
  );
};

export default QaqcPipeWpsView;
